import i18n from "../i18n";
import { LANGUAGE_STORAGE_KEY, normalizeLanguage } from "./language";

export const getCurrentRequestLanguage = () => {
  const candidates = [
    typeof document !== "undefined" ? document.documentElement.lang : null,
    typeof window !== "undefined"
      ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
      : null,
    i18n.resolvedLanguage,
    i18n.language,
    typeof navigator !== "undefined" ? navigator.language : null,
  ];

  const activeLanguage = candidates.find((candidate) => candidate?.trim());

  return normalizeLanguage(activeLanguage);
};

export const withAcceptLanguageHeader = (headers = {}) => {
  return {
    ...headers,
    "Accept-Language": getCurrentRequestLanguage(),
  };
};
